<template>
  <div
    class="modal-crypto"
    :class="currency ? `crypto-${currency}` : ''"
  >
    <!-- HEADER -->
    <div class="crypto-header" v-if="currencyConfig">
      <button class="button-back" @click="goBack">←</button>

      <img
        v-if="currencyIcon"
        :src="currencyIcon"
        class="crypto-icon"
      />

      <div class="header-text">
        {{ currencyName }}
        <div class="text-amount">
          $
          {{ formattedPrice }}
        </div>
      </div>
    </div>

    <!-- DEPOSIT -->
    <CashierCryptoDeposit
      v-if="isDeposit && currencyConfig"
      :currency="currency"
      :currency-config="currencyConfig"
    />

    <!-- WITHDRAW -->
    <CashierCryptoWithdraw
      v-else-if="!isDeposit && currencyConfig"
      :currency="currency"
      :currency-config="currencyConfig"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CashierCryptoDeposit from '@/components/cashier/CashierCryptoDeposit'
import CashierCryptoWithdraw from '@/components/cashier/CashierCryptoWithdraw'

export default {
  name: 'ModalCrypto',
  components: {
    CashierCryptoDeposit,
    CashierCryptoWithdraw
  },

  computed: {
    ...mapGetters([
      'modalsData',
      'settings',
      'cashierCryptoData'
    ]),

    currency() {
      return this.modalsData?.currency || null
    },

    isDeposit() {
      return this.modalsData?.typeCashier === 'deposit'
    },

    currencyConfig() {
      return this.settings?.crypto?.oxapay?.supportedCurrencies?.[this.currency] || null
    },

    currencyName() {
      return this.currencyConfig?.name || this.currency?.toUpperCase() || ''
    },

    currencyIcon() {
      try {
        return require(`@/assets/img/cashier/${this.currency}.png`)
      } catch {
        return null
      }
    },

    formattedPrice() {
      const price =
        this.cashierCryptoData.prices?.[this.currency]?.price || 0
      return Number(price).toLocaleString()
    }
  },

  methods: {
    ...mapActions(['modalsSetShow', 'cashierGetCryptoDataSocket']),

    goBack() {
      this.modalsSetShow(null)
      setTimeout(() => this.modalsSetShow('Cashier'), 200)
    }
  },

  created() {
    this.cashierGetCryptoDataSocket({})
  }
}
</script>


 <style scoped>
.modal-crypto {
  width: 520px;
  background: #0e1b28;
  border-radius: 16px;
  padding: 20px;
  color: #fff;
}

/* HEADER */
.crypto-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
}

.button-back {
  background: #091421;
  border: none;
  color: #9bb0c5;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  cursor: pointer;
}

.crypto-icon {
  width: 36px;
  height: 36px;
}

.header-text {
  display: flex;
  flex-direction: column;
}

.header-text > div:first-child {
  font-size: 16px;
  font-weight: 700;
}

.text-amount {
  font-size: 13px;
  color: #9bb0c5;
}
</style>


